import { render, staticRenderFns } from "./Wxappset.vue?vue&type=template&id=9b940f38"
import script from "./Wxappset.vue?vue&type=script&lang=js"
export * from "./Wxappset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports